import countries from './countries.json';
import { stacks } from './resources';

export const currencies = countries.map(key => ({
    name: key.name,
    currency: key.currency,
}));

export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const jobRoles = stacks
    .filter(key => !key.includes('Other'))
    .map(speciality =>
        speciality?.split(' ').length > 1 && !speciality.includes('tack')
            ? speciality
            : speciality.includes('cience')
            ? 'Data Scientist'
            : `${speciality} Engineer`,
    );
